import { Link } from "react-router-dom";
import styles from "../styles/pages.module.css";

export default function MudanzasAlcorcon() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Mudanzas en Alcorcón, Madrid</h1>
        <span className={styles.lastUpdated}>Mudanzas económicas y profesionales en Alcorcón y zona sur</span>

        <div style={{ textAlign: "center", margin: "1.5rem 0" }}>
          <img
            src="/assets/images/carousel-2.webp"
            alt="Mudanzas en Alcorcón"
            style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
          />
        </div>

        <p>
          Si buscas una <strong>mudanza económica en Alcorcón</strong> sin renunciar a la calidad, Britosa Mudanzas es tu mejor opción. Con base operativa en Móstoles, a pocos minutos de Alcorcón, ofrecemos tarifas competitivas para traslados dentro del municipio y hacia Madrid capital.
        </p>

        <h2>Mudanzas de confianza en el sur de Madrid</h2>
        <p>
          Alcorcón es una de las ciudades con mayor dinamismo inmobiliario del área metropolitana sur. Tanto si te mudas a un piso nuevo en el centro como a una casa en las zonas residenciales de Parque Lisboa o Los Castillos, en Britosa tenemos la flota y el equipo humano para hacerlo posible.
        </p>

        <h2>Servicios destacados en Alcorcón</h2>
        <ul>
          <li><strong>Mudanzas low-cost:</strong> Opciones ajustadas para estudiantes y parejas jóvenes.</li>
          <li><strong>Mudanzas familiares:</strong> Viviendas de 3-4 dormitorios con embalaje completo.</li>
          <li><strong>Traslados de oficinas:</strong> Parque Empresarial de Alcorcón y entornos de negocio.</li>
          <li><strong>Mudanzas con elevador:</strong> Para plantas altas sin ascensor o muebles voluminosos.</li>
          <li><strong>Desmontaje y montaje:</strong> Muebles, lámparas, estanterías y equipamiento de cocina.</li>
        </ul>

        <h2>Zonas de Alcorcón que cubrimos</h2>
        <p>
          Centro, Parque Lisboa, Los Castillos, Alcorcón Sur, La Rivota, Urtinsa, Valderas, Campodón, Fuente Cisneros y todas las urbanizaciones colindantes. Conocemos los mejores accesos y horarios para evitar retenciones.
        </p>

        <div style={{ background: "#f0f9ff", borderRadius: "8px", padding: "1.25rem", margin: "1.5rem 0", border: "1px solid #bae6fd" }}>
          <h3 style={{ marginTop: 0, color: "#0F4C75" }}>Presupuesto gratis para Alcorcón</h3>
          <p style={{ marginBottom: "1rem" }}>
            Aprovecha nuestra cercanía: al estar en Móstoles, los desplazamientos a Alcorcón son mínimos y eso se traduce en ahorro para ti.
          </p>
          <Link to="/presupuesto" style={{ display: "inline-block", padding: "0.6rem 1.4rem", background: "#F97316", color: "#fff", borderRadius: "6px", textDecoration: "none", fontWeight: 600 }}>
            Pedir presupuesto →
          </Link>
        </div>

        <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "2rem" }}>
          <a href="tel:+34691604880">691 60 48 80</a> · Disponibles todos los días de 8:00 a 22:00
        </p>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Britosa Mudanzas - Alcorcón",
          "description": "Mudanzas económicas y profesionales en Alcorcón, Madrid. Desde Móstoles al mejor precio.",
          "url": "https://mudanzasbritosa.com/mudanzas-alcorcon",
          "telephone": "+34691604880",
          "email": "info@mudanzasbritosa.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "C. Río Duero, 28934 Móstoles",
            "addressLocality": "Alcorcón, Madrid",
            "addressRegion": "Madrid",
            "addressCountry": "ES"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.3491,
            "longitude": -3.8288
          },
          "areaServed": {
            "@type": "City",
            "name": "Alcorcón"
          },
          "priceRange": "€€",
          "openingHours": "Mo-Su 08:00-22:00"
        })
      }} />
    </div>
  );
}
